export const getHubspotUtk = (): string => {
  const match = document.cookie.match(/hubspotutk=([a-z0-9-]+)/);
  return match ? match[1] : '';
};
